import styled from 'styled-components';
import { Colors } from "../../../constants/colors";
import { lightTheme } from "../../../themes";

export const List = styled.div`
  margin-left: 20px;
`;
export const Container = styled.div``;

export const ReportElement = styled.div`
  height: 135px;
  padding: 16px;
  background-color: white;
  box-sizing: border-box;
  border-radius: 3px;
  line-height: 1.5em;
  font-size: 15px;
  border: 1px solid ${Colors.veryLightPink};
  min-height: 44px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  text-align: left;
  &:hover {
    background: ${lightTheme.palette.primary.light};
    color: white;
    ul {
      display: block;
    }
  }
  &.active {
    border: 2px solid ${lightTheme.palette.primary.main};
  }
`;

ReportElement.defaultProps = {
  "data-id": "ReportElement"
}

export const Row = styled.div`
  display: flex;
  //margin-left: -10px;
  //margin-right: -10px;
  flex-direction: column;
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;
Row.defaultProps = {
  "data-id": "Row"
}

export const Col = styled.div`
  flex: 1;
  max-width: 380px;
  //padding: 7.5px 10px;
`;
export const Title = styled.div`
  margin: 20px 0px 20px 20px;
  font-family: 'AvenirNext-DemiBold';
  font-size: 22px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3b3b3b;
  width: 100%;
  display: flex;
  flex-direction: column;  
  min-width: 200px;
  align-items: flex-start;

  &.text-right {
    text-align: right;
  }
  &.text-center {
    text-align: center;
  }
  &.text-left {
    text-align: left;
  }
`;

export const ReportTitle = styled.div`
  margin: 0 90px 13px 0;
  font-family: 'AvenirNext-DemiBold';
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  width: 100%;
  display: flex;
  flex-direction: column;  
  min-width: 300px;

  &.text-right {
    text-align: right;
  }
  &.text-center {
    text-align: center;
  }
  &.text-left {
    text-align: left;
  }
`;

export const Description = styled.div`
  font-family: AvenirNext;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  min-width: 350px;

  &.text-right {
    text-align: right;
  }
  &.text-center {
    text-align: center;
  }
  &.text-left {
    text-align: left;
  }
`;

export const Error = styled(Text)`
  font-weight: bold;
  color: ${Colors.dustyRed};
`;



export default {
  panel: {
    'height': 'calc(100% - 35px)',
    'overflowY': 'scroll'
  },
}